module.exports = __webpack_public_path__ + "Rectangle.cf71d2ce2b0b5953c4c4.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/assets/images/Rectangle.svg
// module id = ../../../../../src/assets/images/Rectangle.svg
// module chunks = main